/* eslint-disable react/prop-types */
import React, { Children } from 'react';
import styled from 'styled-components';

import { colors } from '../../../utils/styles';

const containerMarginTop = (noExtraMarginTop, marginTopMob) => {
  if (noExtraMarginTop && marginTopMob) return `${ marginTopMob }px`;
  else if (noExtraMarginTop) return '40px;';
  return '80px;';
};

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  ${ props =>
    props.marginLeft
      ? `margin: 30px 10px 0 ${ props.marginLeft };`
      : 'margin: 30px 10px 0 10px;' };

  ${ props => props.marginTop && `margin-top:${ props.marginTop }px;` };

  @media (max-width: 900px) {
    flex-direction: column;
    margin-top: ${ ({ noExtraMarginTop, marginTopMob }) =>
      containerMarginTop(noExtraMarginTop, marginTopMob) };
  }
`;

const spacing = (imgOnLeft, contentLeftPadding) => {
  if (imgOnLeft && contentLeftPadding)
    return `padding-left: ${ contentLeftPadding }px`;
  else if (imgOnLeft) return 'padding-left: 80px;';
  return 'padding-right: 80px;';
};

const TitleWrapper = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  text-align: left;
  order: 1;
  margin-top: ${ props =>
    props.contentMarginTop ? `${ props.contentMarginTop }px` : '25px' };

  @media (min-width: 901px) {
    margin-top: 0;
    width: 50%;
    ${ ({ imgOnLeft, contentLeftPadding }) =>
      spacing(imgOnLeft, contentLeftPadding) };
  }
`;

const Title = styled.h3`
  font-size: 20px;
  font-weight: 700;
  margin-bottom: 20px;
  line-height: 1.5;

  @media (max-width: 900px) {
    font-size: 15px;
    line-height: 1.2;
    text-align: center;
    margin-bottom: ${ props =>
      props.headingMarginBottom && `${ props.headingMarginBottom }px` };
    ${ ({ titleSpacing }) =>
      titleSpacing &&
      `padding-left: ${ titleSpacing }px; padding-right: ${ titleSpacing }px;` };
  }
`;

const Description = styled.p`
  font-size: 15px;
  width: ${ ({ descriptionWidth }) => descriptionWidth || '93%' };

  ${ props =>
    props.descriptionLineHeight
      ? `line-height: ${ props.descriptionLineHeight };`
      : 'line-height: 1.4;' };

  @media (max-width: 900px) {
    text-align: center;
    font-size: ${ props =>
      props.descriptionFontSize ? `${ props.descriptionFontSize }px` : '13px' };
    width: ${ ({ descriptionWidthMob }) => descriptionWidthMob || '98%' };
    ${ props => (props.descriptionInMid ? 'margin: 0 auto;' : '') };
  }
`;

const DescriptionWrapper = styled.div`
  @media (max-width: 900px) {
    padding: 0 5px;
  }
`;

const ImageWrapper = styled.div`
  flex: 1;
  order: ${ props => (props.imgOnLeft ? 0 : 1) };

  ${ props =>
    props.ImgSpacingOnRight ? `padding-left: ${ props.ImgSpacingOnRight }` : '' };

  ${ props => props.wideImg && 'margin-right:-3%;' };

  ${ props => props.alignLeft && 'text-align: left;' };
  ${ props => props.alignRight && 'text-align: right;' };

  @media (max-width: 900px) {
    order: 0;
    padding: 0;
  }
`;

const Image = styled.img`
  max-width: 100%;
`;

const Step = styled.p`
  color: ${ colors.lightBlueGray };
  font-size: 100px;
  font-weight: 700;
  line-height: 1.15;

  @media (max-width: 900px) {
    display: none;
  }
`;

const ChildContainer = styled.div``;

export default ({
  title,
  description,
  imgSrc,
  imgOnLeft,
  noExtraMarginTop,
  step,
  srcSet,
  ImgSpacingOnRight,
  marginLeft,
  alignLeft,
  alignRight,
  descriptionLineHeight,
  wideImg,
  descriptionInMid,
  marginTop,
  contentLeftPadding,
  marginTopMob,
  contentMarginTop,
  headingMarginBottom,
  descriptionFontSize,
  titleSpacing,
  descriptionWidth,
  descriptionWidthMob,
  button,
  children
}) => (
  <Container
    noExtraMarginTop={ noExtraMarginTop }
    marginLeft={ marginLeft }
    marginTop={ marginTop }
    marginTopMob={ marginTopMob }
  >
    <TitleWrapper
      imgOnLeft={ imgOnLeft }
      contentLeftPadding={ contentLeftPadding }
      contentMarginTop={ contentMarginTop }
    >
      { step && <Step>{ step }</Step> }
      <Title
        headingMarginBottom={ headingMarginBottom }
        titleSpacing={ titleSpacing }
      >
        { title }
      </Title>
      <DescriptionWrapper>
        <Description
          descriptionLineHeight={ descriptionLineHeight }
          descriptionInMid={ descriptionInMid }
          descriptionFontSize={ descriptionFontSize }
          descriptionWidth={ descriptionWidth }
          descriptionWidthMob={ descriptionWidthMob }
        >
          { description }
        </Description>
        { children && <ChildContainer>{ children }</ChildContainer> }
      </DescriptionWrapper>

      { button }
    </TitleWrapper>
    <ImageWrapper
      imgOnLeft={ imgOnLeft }
      ImgSpacingOnRight={ ImgSpacingOnRight }
      alignLeft={ alignLeft }
      alignRight={ alignRight }
      wideImg={ wideImg }
    >
      <Image src={ imgSrc } srcSet={ srcSet } />
    </ImageWrapper>
  </Container>
);



// WEBPACK FOOTER //
// ./src/components/products/events/RegistrationAndTicketing.js